import { Component, Input, OnInit } from '@angular/core';
import { CatalogDependenciesObject } from 'src/app/models/catalog/catalog-dependencies-object.model';

@Component({
  selector: 'app-catalog-tab-dependencies',
  templateUrl: './catalog-tab-dependencies.component.html',
  styleUrls: ['./catalog-tab-dependencies.component.scss']
})
export class CatalogTabDependenciesComponent {

  @Input() dependencies: CatalogDependenciesObject;

  constructor() { }

}
